import React, { useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}


function CalendarMonthSelect({ onMonthSelect, onCloseCalendar, selectedMonth }) {
    const currentDate = new Date();
    const [currentDateState, setCurrentDateState] = useState(selectedMonth || currentDate);
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        setCurrentDateState(selectedMonth || currentDate);
    }, [selectedMonth]);

    const calculateMonthsInYear = (year) => {
        const months = [];
        for (let month = 0; month < 12; month++) {
            const date = new Date(year, month, 1);
            months.push({ date });
        }
        return months;
    };

    const previousYear = () => {
        const newDate = new Date(currentDateState);
        newDate.setFullYear(newDate.getFullYear() - 1);
        setCurrentDateState(newDate);
    };

    const nextYear = () => {
        const newDate = new Date(currentDateState);
        newDate.setFullYear(newDate.getFullYear() + 1);
        setCurrentDateState(newDate);
    };

    const handleMonthSelect = (monthIndex) => {
        const month = months[monthIndex];
        onMonthSelect(month.date);
        onCloseCalendar();
    };

    const handleRowMouseEnter = (index) => {
        setSelectedRow(index);
    };

    const handleRowMouseLeave = () => {
        setSelectedRow(null);
    };

    const months = calculateMonthsInYear(currentDateState.getFullYear());

    return (
        <div className="px-5">
            <div className="grid grid-cols-5">
                <div className='col-span-1 '>
                    {currentDateState.getFullYear() !== new Date().getFullYear() && (
                        <button
                            type="button"
                            onClick={() => setCurrentDateState(new Date())}
                            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-indigo-600 hover:bg-indigo-50 shadow-sm uppercase"
                        >
                            Torna all'anno in corso
                        </button>
                    )}
                </div>
                <button
                    type="button"
                    onClick={previousYear}
                    className="-my-1.5 flex items-center p-1.5 text-gray-400 hover:text-gray-500 col-span-1 justify-end"
                >
                    <ChevronLeftIcon className="h-5 w-5" />
                </button>
                <div className="col-span-1 flex items-center justify-center">
                    <h2 className="text-sm font-semibold text-gray-900">
                        {currentDateState.getFullYear()}
                    </h2>
                </div>
                <button
                    type="button"
                    onClick={nextYear}
                    className="my-1.5 mr-1.5 ml-2 flex items-center p-1.5 text-gray-400 hover:text-gray-500 col-span-1 justify-start"
                >
                    <ChevronRightIcon className="h-5 w-5" />
                </button>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-4 text-center text-xs leading-6 text-gray-500 bg-white z-10">
                {months.map((month, monthIdx) => (
                    <div
                        key={monthIdx}
                        className={classNames(
                            monthIdx === selectedRow ? 'bg-indigo-50' : '',
                            'border-t border-gray-200 py-2'
                        )}
                        onMouseEnter={() => handleRowMouseEnter(monthIdx)}
                        onMouseLeave={handleRowMouseLeave}
                    >
                        <button
                            type="button"
                            className="w-full h-full"
                            onClick={() => handleMonthSelect(monthIdx)}
                        >
                            {month.date.toLocaleString('default', { month: 'long' }).toUpperCase()}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CalendarMonthSelect;

